const ALLOWED_DOMAIN = "rynekpierwotny.pl";
const ALLOWED_EMAILS = ["mmichalak.murapol@gmail.com"];

export function isEmailDomainAllowed(email: string): boolean {
    if (!email) {
        return false;
    }

    const normalized = email.trim().toLowerCase();
    const at = normalized.lastIndexOf("@");

    if (at <= 0 || at === normalized.length - 1) {
        return false;
    }

    const domain = normalized.slice(at + 1);

    return domain === ALLOWED_DOMAIN || ALLOWED_EMAILS.includes(normalized);
}
const ALLOWED_DOMAIN = "rynekpierwotny.pl";
const ALLOWED_EMAILS = ["mmichalak.murapol@gmail.com"];

export function isEmailDomainAllowed(email: string): boolean {
    if (!email) {
        return false;
    }

    const normalized = email.trim().toLowerCase();
    const at = normalized.lastIndexOf("@");

    if (at <= 0 || at === normalized.length - 1) {
        return false;
    }

    const domain = normalized.slice(at + 1);

    return domain === ALLOWED_DOMAIN || ALLOWED_EMAILS.includes(normalized);
}
